import { render, staticRenderFns } from "./MediaGallery.vue?vue&type=template&id=3643cc03&scoped=true&"
import script from "./MediaGallery.vue?vue&type=script&lang=ts&"
export * from "./MediaGallery.vue?vue&type=script&lang=ts&"
import style0 from "./MediaGallery.vue?vue&type=style&index=0&id=3643cc03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643cc03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
